var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { selectPlayerProfilePictureName } from "../../balancingSelectors/selectBalancingPictures";
import { IdLeagues } from "../../constants/IdLeagues";
import { TypeActionPlayerInfo, } from "../info/player/actionPlayerInfo";
import { TypeActionPlayerProfile } from "./actionPlayerProfile";
var initial = {
    coopInfo: undefined,
    id: Long.NEG_ONE,
    level: 0,
    name: "",
    playerLeagueId: IdLeagues.Bronze1,
    profileIcon: "default",
};
export var reducerSelectedPlayerProfile = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPlayerProfile.SetCurrentPlayerProfile:
            return {
                coopInfo: action.coopInfo,
                id: action.id,
                level: action.level,
                name: action.name,
                playerLeagueId: action.playerLeagueId,
                profileIcon: action.profileIcon,
            };
        case TypeActionPlayerProfile.RemoveCurrentPlayerProfile:
            return initial;
        case TypeActionPlayerInfo.ChangeProfilePicture:
            return __assign({}, state, { profileIcon: selectPlayerProfilePictureName(action.id) });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/reducerSelectedPlayerProfile.ts
// module id = 2970
// module chunks = 3